export const Mixin = {
  data() {
    return {
      visible: false,
      pdfUrl: '',
      title: '' //标题名
    }
  },
  methods: {
    // 跳转详情页面
    async toDetails(item) {
      if(item.outLink) {
        window.open(item.outLink, '_blank')
        return
      }
      if (item.fileAnnes === null) {
        this.$message.warning('当前专利信息暂无上传pdf！')
        return
      }
      this.visible = true
      this.title = item.title
      let url = process.env.VUE_APP_PDF_URL
      this.pdfUrl = url + item.fileAnnes[0].filePath
      console.log(this.pdfUrl)
    },
    handleCancel() {
      this.visible = false
    }
  }
}
